"use client";
import PillList from "./pillList";
import {
  Checkbox,
  Container,
  Spacer,
  Typography,
} from "src/components/ct-design";
import Morning from "icons/morning.svg";
import EarlyMorning from "icons/earlyMorning.svg";
import Afternoon from "icons/afternoon.svg";
import Night from "icons/night.svg";

import MultiSelectList from "components/multiSelectList";
import useFilters from "./customHooks/useFilters";
import { useIsAnyFilterSelected } from "./customHooks/useIsAnyFilterSelected";
import { ResultsContext } from "src/context/resultsContext/context";
import { useCallback, useContext, useEffect } from "react";
import cloneDeep from "lodash.clonedeep";
import { FilterList } from "./types";
import { FILTERS_ERROR } from "./constants";
import FilterLoader from "src/containers/results/loaders/filterLoader";

const Filters = ({ disableLoader = false }: { disableLoader?: boolean }) => {
  const { handleChange, handleApplyFilters } = useFilters();
  const { filterList, resultsLoading, resultsData } =
    useContext(ResultsContext);
  const { totalResults, count } = useIsAnyFilterSelected();
  const { handleClearFilters } = useFilters();
  const { noResultsFound } = useContext(ResultsContext);
  const isLoading = disableLoader ? false : resultsLoading;

  useEffect(() => {
    const filterList = document.querySelector(".filter-section") as HTMLElement;
    if (filterList) {
      const height = `${window.innerHeight - 70}px`;
      filterList.style.height = height;
    }
  }, []);
  const getIcons = (type: string) => {
    switch (type) {
      case "Morning":
        return <Morning />;

      case "Afternoon":
        return <Afternoon />;
      case "Night":
        return <Night />;
      case "Early morning":
        return <EarlyMorning />;
    }
  };

  const handleMultiSelectFilters = useCallback(
    (item: FilterList, type: string) => {
      const updateFilterList = cloneDeep(filterList);
      const index = updateFilterList[type].findIndex((el) => el.id === item.id);
      const updateItem = { ...item };
      updateItem.selected = !item.selected;

      updateFilterList[type][index] = updateItem;

      handleApplyFilters(updateFilterList);
    },
    [filterList, handleApplyFilters]
  );

  const handleLocalChange = (type: string, item: any, index: number) => {
    const updateFilterList = handleChange(type, item, index, filterList);
    handleApplyFilters(updateFilterList);
  };
  return (
    <>
      {(!noResultsFound.value ||
        noResultsFound.type.TYPE === FILTERS_ERROR.TYPE) &&
      !isLoading ? (
        <div>
          <div className="pb-4 bb bc-line-500">
            <div className="flex flex-between flex-middle">
              <Container className="flex">
                <Typography variant="B1" className="flex">
                  {totalResults}
                </Typography>
                <Typography variant="B1" className="ml-1" colorCode="#808080">
                  Buses found
                </Typography>
              </Container>

              {count > 0 ? (
                <div onClick={handleClearFilters} className="c-pointer">
                  <Typography
                    variant="L2"
                    className="c-pointer"
                    colorCode="#0F6BFF"
                  >
                    Clear all
                  </Typography>
                </div>
              ) : null}
            </div>
          </div>
          <Container className="mt-4 pb-4 bb bc-line-500">
            <Typography variant="HM4" className="mb-4">
              Departure from {resultsData?.sc?.fromCityName}
            </Typography>

            {filterList.departure.map((item, index) => (
              <div
                key={index}
                className="flex py-3"
                onClick={() => handleLocalChange("departure", item, index)}
              >
                <Checkbox
                  key={"checl"}
                  label={
                    <Container className="flex flex-middle">
                      {getIcons(item.title)}
                      <Typography className="ml-3" variant="P2">
                        {item.description}
                      </Typography>
                    </Container>
                  }
                  checked={item.selected}
                  onClick={() => {}}
                  disabled={false}
                />
              </div>
            ))}
          </Container>
          <Container className="mt-4 pb-2 bb bc-line-500">
            <Typography variant="HM4" className="mb-4">
              Bus type
            </Typography>
            <PillList
              data={filterList.busType}
              onClick={(item, index) =>
                handleLocalChange("busType", item, index)
              }
            />
          </Container>
          <Container className="mt-4 pb-2 bb bc-line-500">
            <Typography variant="HM4" className="mb-4">
              Operator rating
            </Typography>
            <PillList
              data={filterList.starRating}
              onClick={(item, index) =>
                handleLocalChange("starRating", item, index)
              }
            />
          </Container>
          {filterList.pickupPoints?.length > 1 ? (
            <Container className="mt-4 pb-2 bb bc-line-500">
              <Typography variant="HM4" className="mb-4">
                Pick-up points
              </Typography>
              <MultiSelectList
                handleSelect={handleMultiSelectFilters}
                key="pickup-points"
                data={filterList.pickupPoints}
                listTitle="Pick-up points"
                type="pickupPoints"
              />
            </Container>
          ) : null}
          {filterList.dropOffPoints?.length > 1 ? (
            <Container className="mt-4 pb-2 bb bc-line-500">
              <Typography variant="HM4" className="mb-4">
                Drop-off points
              </Typography>
              <MultiSelectList
                handleSelect={handleMultiSelectFilters}
                key="dropoff-points"
                data={filterList.dropOffPoints}
                listTitle="Drop-off points"
                type="dropOffPoints"
              />
            </Container>
          ) : null}
          {filterList.amenities?.length > 1 ? (
            <Container className="mt-4 pb-2 bb bc-line-500">
              <Typography variant="HM4" className="mb-4">
                Amenities
              </Typography>
              <MultiSelectList
                handleSelect={handleMultiSelectFilters}
                key="ammenitites"
                data={filterList.amenities}
                listTitle="Ammenities"
                type="amenities"
                showIcon={true}
              />
            </Container>
          ) : null}
          {filterList.busOperators?.length > 1 ? (
            <Container className="mt-4 pb-2 mb-12">
              <Typography variant="HM4" className="mb-4">
                Bus operator
              </Typography>
              <MultiSelectList
                handleSelect={handleMultiSelectFilters}
                key="bus-operators"
                data={filterList.busOperators}
                listTitle="Bus operators"
                type="busOperators"
              />
            </Container>
          ) : null}
          <Spacer className="mt-2" />
          <Spacer className="mt-2" />
        </div>
      ) : null}

      {isLoading ? (
        <>
          <FilterLoader />
        </>
      ) : null}
    </>
  );
};

export default Filters;
